import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createBlock(_component_b_card, {
    title: _ctx.restorant.name,
    "img-src": _ctx.restorant.image,
    "img-alt": "Image",
    "img-top": "",
    tag: "article",
    style: {"max-width":"20rem"},
    class: "mb-2"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_card_text, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.restorant.description), 1)
        ]),
        _: 1
      }),
      _createElementVNode("a", null, _toDisplayString(_ctx.restorant.name), 1)
    ]),
    _: 1
  }, 8, ["title", "img-src"]))
}